module.exports = __webpack_public_path__ + "img/icon-persona.16b2bf27.svg";